// extracted by mini-css-extract-plugin
module.exports = {"questionImage":"_-_-pharmacy-src-question-questionImages-questionImages__questionImage--1Ns-0"};